module.exports = __webpack_public_path__ + "img/2.449e6ea3.jpg";